export const overrideValuePropsEn = [
  {
    title: 'Free shipping over $50',
    iconName: 'valuepropsbox',
    linkUrl: 'explore/shipping-info',
  },
  {
    title: 'Return any item in-store or online',
    iconName: 'valuepropsreturn',
    linkUrl: 'explore/returns-faq',
  },
  {
    title: 'Best price guaranteed',
    iconName: 'valuepropstag',
    linkUrl: 'explore/price-protection',
  },
  {
    title: 'Membership is free',
    iconName: 'valuepropsmec',
    linkUrl: 'p/member-rewards',
  },
  {
    title: 'Product satisfaction guaranteed',
    iconName: 'valuepropscheck',
    linkUrl: 'explore/returns-and-guarantee',
  },
];

export const overrideValuePropsFr = [
  {
    title: 'Livraison gratuite à partir de 50$',
    iconName: 'valuepropsbox',
    linkUrl: 'explore/shipping-info',
  },
  {
    title: "Retourner n'importe quel article",
    iconName: 'valuepropsreturn',
    linkUrl: 'explore/returns-faq',
  },
  {
    title: 'Meilleur prix garanti',
    iconName: 'valuepropstag',
    linkUrl: 'explore/price-protection',
  },
  {
    title: "Devenez membre c'est gratuit",
    iconName: 'valuepropsmec',
    linkUrl: 'p/membres-mec',
  },
  {
    title: 'Satisfaction du produit garantie',
    iconName: 'valuepropscheck',
    linkUrl: 'explore/returns-and-guarantee',
  },
];
